/// <amd-module name="SuiteCommerce.Testimonials.Testimonial.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Testimonials.Testimonial.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TestimonialModel = /** @class */ (function (_super) {
        __extends(TestimonialModel, _super);
        function TestimonialModel(options) {
            var _this = _super.call(this, options) || this;
            _this.hasImageURL = !!options.imageURL;
            _this.hasTextBody = !!options.textBody;
            _this.hasSubTitle = !!options.subTitle;
            _this.hasTitle = !!options.title;
            _this.hasLink = !!options.link;
            return _this;
        }
        Object.defineProperty(TestimonialModel.prototype, "id", {
            get: function () {
                return this.get('id');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "title", {
            get: function () {
                return this.get('title');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "subTitle", {
            get: function () {
                return this.get('subTitle');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "textBody", {
            get: function () {
                return this.get('textBody');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "link", {
            get: function () {
                return this.get('link');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "imageURL", {
            get: function () {
                return this.get('imageURL');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "altText", {
            get: function () {
                return this.get('altText');
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "hasTitle", {
            get: function () {
                return this.get('hasTitle');
            },
            set: function (hasTitle) {
                this.set('hasTitle', hasTitle);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "hasSubTitle", {
            get: function () {
                return this.get('hasSubTitle');
            },
            set: function (hasSubTitle) {
                this.set('hasSubTitle', hasSubTitle);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "hasTextBody", {
            get: function () {
                return this.get('hasTextBody');
            },
            set: function (hasTextBody) {
                this.set('hasTextBody', hasTextBody);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "hasImageURL", {
            get: function () {
                return this.get('hasImageURL');
            },
            set: function (hasImageURL) {
                this.set('hasImageURL', hasImageURL);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(TestimonialModel.prototype, "hasLink", {
            get: function () {
                return this.get('hasLink');
            },
            set: function (hasLink) {
                this.set('hasLink', hasLink);
            },
            enumerable: true,
            configurable: true
        });
        TestimonialModel.prototype.isEmpty = function () {
            return !this.hasTitle &&
                !this.hasSubTitle &&
                !this.hasTextBody &&
                !this.hasImageURL;
        };
        return TestimonialModel;
    }(Backbone_1.Model));
    exports.TestimonialModel = TestimonialModel;
});
